import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateAdminInvoiceStats = {
  adminInvoiceStats: { data: null, loading: false, error: null },
};

export const adminInvoiceStats = createAsyncThunk(
  "payment/adminInvoiceStats",
  async (params = {}, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/payments/apipay/admin/invoices/stats/`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(res.response?.data || { error: "Ошибка загрузки статистики" })
      );
  }
);

export const reducerAdminInvoiceStats = {
  [adminInvoiceStats.pending]: (state) => {
    state.adminInvoiceStats.loading = true;
    state.adminInvoiceStats.error = null;
  },
  [adminInvoiceStats.fulfilled]: (state, action) => {
    state.adminInvoiceStats.loading = false;
    state.adminInvoiceStats.data = action.payload;
    state.adminInvoiceStats.error = null;
  },
  [adminInvoiceStats.rejected]: (state, action) => {
    state.adminInvoiceStats.loading = false;
    state.adminInvoiceStats.data = null;
    state.adminInvoiceStats.error = action.payload;
  },
};
